// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PressReleases__Wrapper_3BFrO","Cards":"PressReleases__Cards_ZGCjg grid"};